"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRowFetcher = exports.getAllFromSliceable = exports.GraphQLSliceable = void 0;
const tslib_1 = require("tslib");
/**
 * The GraphQLSliceable is used by the VizPortal explorers and the DC3 grids to make paginated GraphQL queries.
 */
class GraphQLSliceable {
    constructor(params, partialQueryVariables, client) {
        this.params = params;
        this.partialQueryVariables = partialQueryVariables;
        this.client = client;
    }
    getResultRows(listResult, resultData) {
        if (listResult && listResult.nodes && listResult.totalCount !== null) {
            if (this.params.setRowCount) {
                this.params.setRowCount(listResult.totalCount);
            }
            return listResult.nodes.map(node => this.params.mapResultNode(node, resultData));
        }
        else {
            if (this.params.setRowCount) {
                this.params.setRowCount(0);
            }
            return [];
        }
    }
    getTotalCount(listResult) {
        return listResult ? listResult.totalCount : 0;
    }
    getSlice(sliceBoundaries) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const variables = Object.assign(Object.assign({}, this.partialQueryVariables), { offset: sliceBoundaries.start, first: sliceBoundaries.size });
            const apolloQueryResult = yield this.client.query({
                // TODO: remove this cast when updating apollo dependencies (TFS 944332)
                // This cast is due to the sloppy nature of some of the apollo types not properly addressing the fact that
                // string values are what are being passed as DocumentNodes which runs perfectly fine until we add graphql types
                // that specify typing on document nodes.
                query: this.params.queryGql,
                variables,
            });
            const resultData = apolloQueryResult.data;
            const listResult = this.params.selectConnectionListResult(resultData);
            return {
                items: this.getResultRows(listResult, resultData),
                totalCount: this.getTotalCount(listResult),
                // TODO: Revisit the use of this cast when updating graphql/apollo dependencies (types) -- TFS 944332
                // The following dangerous cast SHOULD be safe so long as the locally GraphQLError type stays in sync
                // with the types of errors returned by the relationship service
                errors: apolloQueryResult.errors,
            };
        });
    }
}
exports.GraphQLSliceable = GraphQLSliceable;
const defaultBlockSize = 1000;
function getAllFromSliceable(sliceable, blockSize = defaultBlockSize) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        let items = [];
        let itemsRemaining = null;
        while (itemsRemaining === null || itemsRemaining > 0) {
            const slice = yield sliceable.getSlice({ start: items.length, size: blockSize });
            items = items.concat(slice.items);
            itemsRemaining = slice.totalCount - items.length;
        }
        return items;
    });
}
exports.getAllFromSliceable = getAllFromSliceable;
function makeRowsForItems(items) {
    return items.map(item => ({
        key: item.id,
        data: item,
    }));
}
/**
 * For the Data Catalog grids, we transform the sliceable result into data grid rows.
 * The VizPortal Client explorer code has a different mechanism for doing this transformation.
 */
function makeRowFetcher(sliceableParams, partialQueryVariables, client) {
    const sliceable = new GraphQLSliceable(sliceableParams, partialQueryVariables, client);
    return function queryRows(pageBoundaries) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { start, end } = pageBoundaries;
            const slice = yield sliceable.getSlice({ start, size: end - start + 1 });
            return {
                rows: makeRowsForItems(slice.items),
                totalCount: slice.totalCount,
                errors: slice.errors,
            };
        });
    };
}
exports.makeRowFetcher = makeRowFetcher;
//# sourceMappingURL=GraphQLSliceable.js.map